import { useQuery } from '@tanstack/react-query';

import { Routing } from '@/modules/Routing';
import { useRoutesStore } from '@/stores/useRoutesStore';
import { RouteLocationType } from '@/types/RouteLocationType';

export const useRoutes = () => {
  const origin = useRoutesStore((state) => state.routeLocations[RouteLocationType.ORIGIN]);
  const destination = useRoutesStore((state) => state.routeLocations[RouteLocationType.DESTINATION]);
  const time = useRoutesStore((state) => state.time);

  return useQuery({
    queryKey: ['routes', { origin, destination, time }],
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    queryFn: async () => Routing.get({ origin: origin!, destination: destination!, time }),
    enabled: !!origin && !!destination && time.date.isValid(),
    staleTime: Infinity,
    retry: false,
    refetchOnWindowFocus: false,
  });
};
